var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSettingBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054",
    transform: "translate(-174 -1896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(174 1896)",
    fill: "#24397a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "build_circle-24px",
    transform: "translate(189 1912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M22,2A20,20,0,1,0,42,22,20.007,20.007,0,0,0,22,2Zm0,36A16,16,0,1,1,38,22,16.021,16.021,0,0,1,22,38Z",
    transform: "translate(-2 -2)",
    fill: "#fff",
    stroke: "#24397a",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M20.229,16.009a6.919,6.919,0,0,0-9.82-8.42l4.7,4.7-2.82,2.82-4.7-4.7a6.919,6.919,0,0,0,8.42,9.82l6.82,6.82a.99.99,0,0,0,1.42,0l2.8-2.8a.99.99,0,0,0,0-1.42Z",
    transform: "translate(2.751 2.751)",
    fill: "#fff",
    stroke: "#24397a",
    strokeWidth: 1,
    fillRule: "evenodd"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingBg);
export default __webpack_public_path__ + "static/media/setting-bg.c5d46af882bd4a48846d95a1ab9ac5bc.svg";
export { ForwardRef as ReactComponent };